import { ViewLabelmappingModalComponent } from './view-labelmapping-modal/view-labelmapping-modal.component';
import { ViewExcelModalComponent } from './view-excel-modal/view-excel-modal.component';
import { ManageService } from './../../service/manage.service';
import { DBConnectorService } from './../../service/test.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SectorModel } from './../../service/sector.model';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription, Observable } from 'rxjs';
import { LoggedInGuard } from '../../authentication/logged-in.guard';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-backup',
  templateUrl: './backup.component.html',
  styleUrls: ['./backup.component.css']
})
export class BackupComponent implements OnInit, OnDestroy {
  DownloadPredict: string;
  DownloadTax: string;
  DownloadModel: string;
  DownloadXL: string;
  bsModalRef: BsModalRef
  sectormodel = new SectorModel;
  result: any = {};
  Sub: Subscription;

  constructor(private http: HttpClient,
    private dbconnectorservice: DBConnectorService,
    private manage: ManageService,
    private _dialogService: BsModalService,
    private loggedInGuard: LoggedInGuard) {
    this.sectormodel.SectorName = this.dbconnectorservice.SectorName;
    this.sectormodel.ModelName = this.dbconnectorservice.ModelName;
    this.sectormodel.User = this.dbconnectorservice.username;
    this.dbconnectorservice.onGetSec.subscribe((res) => { this.sectormodel.SectorName = res; });
    this.Sub = this.dbconnectorservice.onGetMod.subscribe((res) => { this.sectormodel.ModelName = res; this.backupTab(); });
  }

  backupTab() {
    if (this.loggedInGuard.isSessionValid()) {
      if (this.sectormodel.SectorName != null && this.sectormodel.SectorName != 'null') {
        this.result = {};
        this.manage.BackupTab(this.sectormodel)
          .subscribe(
            (data) => {
              this.result = data;
              console.log(this.result);
              this.DownloadXL = '/api/Download/DownloadXL?Sector=' + this.dbconnectorservice.SectorName + '&Model=' + this.dbconnectorservice.ModelName;
              this.DownloadModel = '/api/Download/DownloadModel?Sector=' + this.dbconnectorservice.SectorName + '&Model=' + this.dbconnectorservice.ModelName;
              this.DownloadTax = '/api/Download/DownloadTax?Sector=' + this.dbconnectorservice.SectorName + '&Model=' + this.dbconnectorservice.ModelName;
              this.DownloadPredict = '/api/Download/DownloadPredict?Sector=' + this.dbconnectorservice.SectorName + '&Model=' + this.dbconnectorservice.ModelName + '&User=' + this.dbconnectorservice.username;

            });
      } else {
        this.result['BackupError'] = 'Sector and Model have not been selected!';
      }
    }
  }

  showExcelModal() {
    this.bsModalRef = this._dialogService.show(ViewExcelModalComponent)
    // const disposable = this.dialogService.addDialog(ViewExcelModalComponent, {
    //   // title: 'Confirm title',
    //   // message: 'Confirm message'
    // })
    //   .subscribe((isConfirmed) => {
    //     // We get dialog result

    //   });
    // We can close dialog calling disposable.unsubscribe();
    // If dialog was not closed manually close it by timeout
    // setTimeout(() => {
    //   disposable.unsubscribe();
    // }, 10000);
  }

  showLabelModal() {
    this.bsModalRef = this._dialogService.show(ViewLabelmappingModalComponent)
    // const disposable = this.dialogService.addDialog(ViewLabelmappingModalComponent, {
    //   // title: 'Confirm title',
    //   // message: 'Confirm message'
    // })
    //   .subscribe((isConfirmed) => {
    //     // We get dialog result
    //   });
    // We can close dialog calling disposable.unsubscribe();
    // If dialog was not closed manually close it by timeout
    // setTimeout(() => {
    //   disposable.unsubscribe();
    // }, 10000);
  }

  // ModelFileUpload
  fileChange(event: any) {
    alert('Uploading Model File');
    const fileList: FileList = event.target.files;
    console.log(fileList);
    if (fileList.length > 0) {
      for (let i in fileList) {
        const file: File = fileList[i];
        let formData: FormData = new FormData();
        formData.append('uploadFile', file, file.name);
        //console.log(formData);
        let headers = new Headers()
        //headers.append('Content-Type', 'json');  
        headers.append('Accept', 'application/json');
        let options = {
          headers: new HttpHeaders({
            'Accept': 'application/json'
          })
        }
        let apiUrl = '/api/ManageBackup/SaveUploadedModelFile' + '?Sector=' + this.dbconnectorservice.SectorName + '&Model=' + this.dbconnectorservice.ModelName;
        //console.log(apiUrl);
        this.http.post<any>(apiUrl, formData, options)
          .subscribe(
            (data) => {
              console.log(data);
              this.result = data;
            }
          )
      }
      alert('File Uploaded');
    }
    this.backupTab();
  }

  fileDownload(URL: string) {
    if (this.loggedInGuard.isSessionValid()) {
      alert('Starting file download...');

      // const headers = new Headers({ 'Content-Type': 'application/json' });
      //const options = new RequestOptions({ headers: headers, responseType: ResponseContentType.Blob });
      const options: object = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        responseType: 'blob',
        observe: 'response'
      }
      const url = URL;
      this.http.post<any>(url, '', options)
        .subscribe(res => {

          const parsedResponse = res.body;
          const contentType = 'application/octet-stream';
          const blob = new Blob([parsedResponse], { type: contentType });
          const url = window.URL.createObjectURL(blob);
          // window.open(url);
          const contentDispositionHeader = res.headers.get('content-disposition');
          const filename = contentDispositionHeader.split('=')[1].trim();

          const a = document.createElement('a');
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);

        });
    }
  }

  // filedownload(){
  //   let url = '/api/Download/DownloadXL' + '?Sector=' + this.sectormodel.SectorName + '&Model=' + this.sectormodel.ModelName;
  //   this.dbconnectorservice.getMultipart(url)
  //   .subscribe(blob => {
  //     var link = document.createElement('a');
  //     link.href = window.URL.createObjectURL(blob);
  //     link.download = 'trainduu.xlsx';
  //     link.click();
  //   })
  // }

  ngOnInit() {

    this.backupTab();

  }
  ngOnDestroy() {
    this.Sub.unsubscribe();
  }

}
